/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Use_3_ValueInputs */

const en_svc_n8n_use_3_value = /** @type {(inputs: Svc_N8n_Use_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data gathered from several tools and a summary drafted on schedule.`)
};

const lv_svc_n8n_use_3_value = /** @type {(inputs: Svc_N8n_Use_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati no vairākiem rīkiem tiek savākti un kopsavilkums sagatavots pēc grafika.`)
};

/**
* | output |
* | --- |
* | "Data gathered from several tools and a summary drafted on schedule." |
*
* @param {Svc_N8n_Use_3_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_use_3_value = /** @type {((inputs?: Svc_N8n_Use_3_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Use_3_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_use_3_value(inputs)
	return en_svc_n8n_use_3_value(inputs)
});